export const SUBMISSION_TEXT =
  "Our team is reviewing your submissions and will get back to you in 2-3 business days.";
